import React, { useState } from 'react';
import { Typography, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import { updateAuth0User } from '../../api/tenantApi';

const AccountInfo = ({ user, isExpanded, onToggle }) => {
  const [isVisibleCurrPass, setIsVisibleCurrPass] = useState(false);
  const [isVisibleNewPass, setIsVisibleNewPass] = useState(false);
  const [isVisibleConfirmPass, setIsVisibleConfirmPass] = useState(false);
  const [isVisibleEnterPass, setIsVisibleEnterPass] = useState(false);
  const [formData, setFormData] = useState({
    fullName: user?.name || '',
    email: user?.email || '',
    phoneNumber: user?.user_metadata?.phone_number || '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleInputChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleUpdateUser = async () => {
    try {
      const subId = localStorage.getItem("subId");
      const updatedFields = {};
      const passwordUpdate = {};

      if (formData.fullName.length !== 0 && formData.fullName !== user.name) {
        updatedFields.name = formData.fullName;
      }
      if (formData.email.length !== 0 && formData.email !== user.email) {
        updatedFields.email = formData.email;
      }
      if (formData.phoneNumber.length !== 0 && formData.phoneNumber !== user.user_metadata.phone_number) {
        updatedFields.user_metadata = {
          phone_number: formData.phoneNumber,
        };
      }

      if (formData.newPassword.length !== 0) {
        if (formData.newPassword === formData.confirmPassword) {
          passwordUpdate.password = formData.newPassword;
          passwordUpdate.connection = 'Username-Password-Authentication';
        } else {
          toast.error("Confirm password not same as new password");
          return;
        }
      }

      if (Object.keys(updatedFields).length > 0) {
        await updateAuth0User(subId, updatedFields);
        toast.success('User general info updated successfully');
      }

      if (Object.keys(passwordUpdate).length > 0) {
        await updateAuth0User(subId, passwordUpdate);
        toast.success('Password updated successfully');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Update failed');
    }
  };

  if (!isExpanded) return null;

  return (
    <div className="expanded-content-1" style={{
      background: '#FAFAFC',
      opacity: '1',
      boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.08)',
      borderRadius: '0 0 8px 8px',
      padding: '20px',
    }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        <div>
          <Typography variant="h6" gutterBottom>Account Information</Typography>
          <TextField
            fullWidth
            label="Full Name"
            value={formData.fullName}
            onChange={handleInputChange('fullName')}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Email"
            value={formData.email}
            onChange={handleInputChange('email')}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Phone Number"
            value={formData.phoneNumber}
            onChange={handleInputChange('phoneNumber')}
            margin="normal"
          />
        </div>

        <div>
          <Typography variant="h6" gutterBottom>Password Management</Typography>
          <TextField
            fullWidth
            label="New Password"
            type={isVisibleNewPass ? 'text' : 'password'}
            value={formData.newPassword}
            onChange={handleInputChange('newPassword')}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Confirm Password"
            type={isVisibleConfirmPass ? 'text' : 'password'}
            value={formData.confirmPassword}
            onChange={handleInputChange('confirmPassword')}
            margin="normal"
          />
          <button
            onClick={handleUpdateUser}
            style={{
              marginTop: '20px',
              background: '#5186EC',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountInfo; 